/**
 * 描述：收起正文
 * 日期：2017-11-22
 * 作者：lileilei
 */
'use strict';
angular.module("toggleMainTextModule", [])
    .directive("toggleMainText", [function() {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            templateUrl: './editingCenter/directive/toggleMainText/toggleMainText_tpl.html',
            link: function(scope, $elem, $attrs) {
                initStatus();
                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        zhengwen: false
                    };
                    // insertToggleMenu();
                }
                /**
                 * [insertToggleMenu description] 在编辑器上部插入dom
                 * @return {[type]} [description]
                 */
                // function insertToggleMenu(){
                //     var dom=['<div ng-if="status.zhengwen">',
                //             '<a class="drop_text" ng-class="{true:\'zhankai\',false:\'shouqi\'}[status.zhengwen]" ng-click="toggleEditor()">',
                //             '<i class="iconfont icon-shouqizhengwen">',
                //             '</i><span ng-if="!status.zhengwen">收起正文</span>',
                //             '<span ng-if="status.zhengwen">展开正文</span></a>',
                //         '</div>'].join('');
                //     $(dom).insertBefore('.editor_body');
                // }
                /**
                 * [toggleEditor description] 切换编辑器显示隐藏
                 * @return {[type]} [description]
                 */
                scope.toggleEditor = function() {
                    scope.status.zhengwen = !scope.status.zhengwen;
                    if ($scope.status.zhengwen) { //隐藏编辑器
                        $(".body_manuscript_content").addClass('editorHidden');
                    } else {
                        $(".body_manuscript_content").removeClass('editorHidden');
                    }
                };
            }
        };
    }]);